/** 아이콘 대체 텍스트 글리프 단일 출처 — 여기 없는 글리프는 사용 금지 */
export const GLYPHS = {
  close: '×',
  prev: '‹',
  next: '›',
  down: '▾',
  up: '▴',
  more: '⋯',
  arrow: '→',
} as const;
